import { ConfigurationService } from '@/services/configuration.service';

export default {
  namespaced: true,
  state: {
    config: {},
  },
  mutations: {
    SET_STATE(state, payload) {
      state[payload.state] = payload.value;
    },
  },
  getters: {
    isUserSupportsAdminPatientChat(state, getter, rootState) {
      return state.config.admin_chat?.includes(
        rootState.user?.currentUser?.state
      );
    },
    isDeepSleepUpsellEnabled(state) {
      return state.config.deepsleep?.enabled === true;
    },
    getNonRxUpsellDisplayStatus(state) {
      return state.config.nonrx_supplement?.NONRX_ENABLED;
    },
    isNonRxSkincareEnabled(state) {
      return state.config.skincare?.enabled;
    },
    getCampaignBannerValues(state) {
      const campaignBannerValues = state.config.campaign_banner.find(item => item.environment === process.env.VUE_APP_SERVER);
      if (!campaignBannerValues) {
        return {
          enabled: false,
          startDate: null,
        }
      }
      return {
        enabled: campaignBannerValues.enabled,
        startDate: campaignBannerValues.start_date,
      }
    }
  },
  actions: {
    async get({ commit }) {
      const response = await ConfigurationService.get();
      const hardcodedDefaults = {
        formacode_used: {},
        admin_chat: ['IA', 'MI', 'NH', 'NC'],
        non_flow_face: ['NY', 'MD'],
        doctor_router: {
          enabled: false,
          byDoctorEnabled: false,
        },
      };

      const mergedConfig = {
        ...response.data,
        ...hardcodedDefaults,
      };

      commit('SET_STATE', {
        state: 'config',
        value: mergedConfig,
      });

      return mergedConfig;
    },
  },
};
